class ListBox extends HTMLElement {
    constructor() {
        super();

        this.combobox = this.querySelector("#combobox");
        this.comboboxLabel = this.querySelector("#combobox-label");
        this.listbox = this.querySelector("#listbox-menu");
        this.options = Array.from(this.querySelectorAll('[role="option"]'));
        this.sections = Array.from(document.querySelectorAll("#page-sections .page-sections-content .page-section"));
        this.selected = this.options.filter((option) => option.getAttribute("aria-selected") === "true")[0];
        this.comboboxHandler = this.toggle.bind(this);

        this.combobox.addEventListener("click", this.comboboxHandler);
        window.addEventListener("DOMContentLoaded", () => {
            this.listbox.setAttribute("style", `--offset-height: ${this.listbox.offsetHeight}px; --closed-height: 0;`);
        });
    }

    connectedCallback() {
        this.optionHandler = this.onClickOption.bind(this);
        this.options.forEach((option) => {
            option.addEventListener("click", this.optionHandler, false);
        });
    }

    toggle() {
        this.combobox.getAttribute("aria-expanded") === "true" ? this.close() : this.open();
    }

    open() {
        this.combobox.setAttribute("aria-expanded", "true");
    }

    close() {
        this.combobox.setAttribute("aria-expanded", "false");
    }

    onClickOption(event) {
        if (event.target) {
            const selectedOption = {
                option: event.target,
                query: event.target.dataset.value,
                text: event.target.innerText,
            };
            this.updateCombobox(selectedOption);
            this.selectedSection = this.sections.filter((section) => section.id === selectedOption.query)[0];
            this.selectedSection.scrollIntoView({ behavior: "smooth" });
            this.close();
        }
    }

    updateCombobox(data) {
        this.comboboxLabel.innerText = data.text;
        if (this.selected !== data.option) {
            this.selected.setAttribute("aria-selected", "false");
            this.selected = data.option;
            this.selected.setAttribute("aria-selected", "true");
        }
    }
}

customElements.define("list-box", ListBox);
